// "Adiantamento já feito" (D-0120): aviso de que o cliente já pagou fora do sistema.
// Só organiza o Financeiro; recibo, Informar Crédito e baixa seguem como sempre.
// Espelho na API: App\Services\Financeiro\AdiantamentoClientePagouPolicy.
export const PERFIS_CLIENTE_JA_PAGOU = [
    'admin', 'diretor', 'evento', 'gerenteevento', 'gerenteeventointernacional',
    'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento',
];

export const BLOQUEIO_BAIXA_CLIENTE_JA_PAGOU = 'A marcação não pode mudar depois do crédito/baixa do adiantamento.';

export const podeMarcarClienteJaPagou = (perfil) =>
    PERFIS_CLIENTE_JA_PAGOU.includes(String(perfil || '').trim().toLowerCase());

const excluido = (adt) => !!(adt.removido_em || adt.excluido);

/** Creditado pelo Financeiro ou baixado: só leitura. */
export const baixaRealizadaAdiantamento = (adt) =>
    String(adt.situacao) === '2' || adt.status_pagamento === 'creditado';

export function estadoClientePagou(adt, perfil) {
    if (!adt) return null;
    const marcado = !!adt.cliente_ja_pagou;
    const baixada = baixaRealizadaAdiantamento(adt);
    const permitido = podeMarcarClienteJaPagou(perfil);
    return {
        marcado,
        editavel: permitido && !baixada && !excluido(adt),
        bloqueio: baixada ? BLOQUEIO_BAIXA_CLIENTE_JA_PAGOU : null,
    };
}
